import React from 'react';
import { experiences } from '../data/mockData';
import { useTheme } from '../context/ThemeContext';

const ExperienceSection = () => {
  const { isDark } = useTheme();
  
  return (
    <section id="experience" className="experience-section">
      {/* Section Title */}
      <h2 className="section-title">
        15 YEARS OF <span className="section-title-faded">EXPERIENCE</span>
      </h2>

      {/* Experience List */}
      <div className="experience-list">
        {experiences.map((exp) => (
          <div key={exp.id} className="experience-card">
            <div className="experience-main">
              <div className="experience-header">
                <h3 className="experience-company">{exp.company}</h3>
              </div>
              <div className="experience-description">
                {exp.description.split('\n\n').map((para, idx) => (
                  <p key={idx} className="experience-desc-para">{para}</p>
                ))}
              </div>
            </div>
            <div className="experience-meta">
              <span className="experience-duration">{exp.duration}</span>
            </div>
          </div>
        ))}
      </div>

      <style jsx>{`
        .experience-section {
          padding-bottom: 60px;
        }

        .section-title {
          font-family: 'Poppins', sans-serif;
          font-size: clamp(36px, 6vw, 56px);
          font-weight: 700;
          color: ${isDark ? '#fff' : '#151312'};
          line-height: 1;
          letter-spacing: -0.02em;
          margin: 0 0 32px 0;
          transition: color 0.3s ease;
        }

        .section-title-faded {
          color: ${isDark ? 'rgba(182, 180, 189, 0.2)' : 'rgba(21, 19, 18, 0.15)'};
        }

        .experience-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .experience-card {
          position: relative;
          padding: 24px;
          border-radius: 16px;
          border: 1px solid ${isDark ? 'rgba(182, 180, 189, 0.1)' : 'rgba(0, 0, 0, 0.08)'};
          display: flex;
          gap: 24px;
          background: ${isDark ? 'transparent' : 'rgba(255, 255, 255, 0.5)'};
          transition: border-color 0.3s ease, background-color 0.3s ease;
        }

        .experience-main {
          flex: 1;
        }

        .experience-header {
          margin-bottom: 8px;
        }

        .experience-company {
          font-family: 'Poppins', sans-serif;
          font-size: 20px;
          font-weight: 600;
          color: ${isDark ? '#fff' : '#151312'};
          margin: 0;
          transition: color 0.3s ease;
        }

        .experience-description {
          margin: 0;
          max-width: 500px;
        }

        .experience-desc-para {
          font-family: 'Poppins', sans-serif;
          font-size: 14px;
          font-weight: 400;
          color: ${isDark ? '#998f8f' : '#64748b'};
          line-height: 1.5;
          margin: 0 0 10px 0;
          transition: color 0.3s ease;
        }

        .experience-desc-para:last-child {
          margin-bottom: 0;
        }

        .experience-meta {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: flex-start;
          min-width: 140px;
        }

        .experience-duration {
          font-family: 'Poppins', sans-serif;
          font-size: 14px;
          font-weight: 400;
          color: ${isDark ? '#998f8f' : '#64748b'};
          text-align: right;
          transition: color 0.3s ease;
        }

        @media (max-width: 768px) {
          .experience-card {
            flex-direction: column;
            gap: 12px;
            padding: 20px;
          }

          .experience-meta {
            align-items: flex-start;
          }

          .section-title {
            font-size: 32px;
            margin-bottom: 24px;
          }

          .experience-company {
            font-size: 18px;
          }

          .experience-desc-para {
            font-size: 13px;
          }
        }

        @media (max-width: 480px) {
          .experience-card {
            padding: 16px;
          }

          .experience-company {
            font-size: 16px;
          }
        }
      `}</style>
    </section>
  );
};

export default ExperienceSection;
